import { render, staticRenderFns } from "./actives.vue?vue&type=template&id=b53eea54&scoped=true&"
import script from "./actives.vue?vue&type=script&lang=js&"
export * from "./actives.vue?vue&type=script&lang=js&"
import style0 from "./actives.vue?vue&type=style&index=0&id=b53eea54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53eea54",
  null
  
)

export default component.exports